import React from "react";
import { FaThumbtack } from "react-icons/fa";

const PinButton = ({
  pinned,
  onToggle,
  disabled = false,
  className = "",
  size = 14,
}) => (
  <button
    type="button"
    disabled={disabled}
    aria-pressed={pinned}
    aria-label={pinned ? "Unpin" : "Pin to top"}
    title={pinned ? "Unpin" : "Pin to top"}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onToggle();
    }}
    onContextMenu={(e) => e.stopPropagation()}
    className={`p-1 rounded-md transition-colors disabled:opacity-30 disabled:cursor-not-allowed ${
      pinned ? "text-amber-400" : "text-gray-500 hover:text-gray-300"
    } ${className}`}
  >
    <FaThumbtack size={size} className={pinned ? "" : "rotate-45"} />
  </button>
);

export default PinButton;
